import React from 'react'
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
const ModalConfirm = ({ visible, onClose, onConfirm, status, title, msm, btnText, buttoms }) => {
    const customStyles = {
        overlay: {
            backgroundColor: '#00000077'
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',

        },
    };

    return (
        <Modal
            isOpen={visible}
            onAfterOpen={() => { }}
            onRequestClose={() => { onClose(); }}
            style={customStyles}
            contentLabel="Example Modal"
            className=''>
            <div className='flex flex-col w-[20vw] min-w-[200px] '>
                <div className='flex justify-between mb-2'>
                    <div>{title}</div>
                    <button onClick={onClose}><CloseIcon></CloseIcon></button>
                </div>
                <div>{msm}</div>
                <div className='flex w-full justify-end space-x-4 mt-5'>
                    <div className={`bg-blue-500 hover:bg-blue-600 rounded-md px-4 py-2  text-white cursor-pointer flex justify-center items-center select-none`} onClick={onConfirm}  >OK</div>
                    <div className={`bg-blue-500 hover:bg-blue-600 rounded-md px-4 py-2  text-white cursor-pointer flex justify-center items-center select-none`} onClick={onClose}  >Cancelar</div>

                </div>

            </div>

        </Modal>
    )
}

export default ModalConfirm